// extracted by mini-css-extract-plugin
module.exports = {"container":"container__1OUoT","checkbox":"checkbox__VrIbN"};